<template>
    <div>
        <h3 class="title is-3">Employee Leave</h3>
        <hr />
        <router-view/>
    </div>
</template>

<script>
export default {};
</script>
